export const NpsScoreSkilledWorker = "Skilled Worker";
export const NpsScoreSkilledWorkerInside = "Skilled Worker Inside";
export const NpsScoreSponsorship = "Sponsor Licence";
export const NpsScoreAssessment = "Candidate Assessment";
export const NpsScoreSkilledWorkerCoS = "Skilled Worker CoS";
export const NpsScoreSkilledWorkerCosInside = "Skilled Worker CoS Inside";
export const NpsScoreSkilledWorkerDependant = "Dependant Inside";
export const NpsScoreMonthlyChecklist = "Monthly Checklist";
export const NpsScoreReportChange = "Report Change";

export const NpsScoreTypes: Record<string, string> = {
  skilled_worker: NpsScoreSkilledWorker,
  skilled_worker_inside: NpsScoreSkilledWorkerInside,
  sponsor_licence: NpsScoreSponsorship,
  skilled_worker_cos: NpsScoreSkilledWorkerCoS,
  skilled_worker_cos_inside: NpsScoreSkilledWorkerCosInside,
  monthly_checklist: NpsScoreMonthlyChecklist,
  report_change: NpsScoreReportChange,
  // dependant: NpsScoreSkilledWorkerDependant,
  // candidate_assessment: NpsScoreAssessment,
};

export const getNpsScoreKeyByValue = (value: string): string => {
  const key = Object.entries(NpsScoreTypes).find(([, val]) => val === value)?.[0];

  return key || "";
};
